import { AddressType } from '../types';

const parseAddressTypesResult = (result: { Data?: AddressType[] } | AddressType[]): AddressType[] => {
  return Array.isArray(result) ? result : result?.Data || [];
};

export default parseAddressTypesResult;
